export default __webpack_public_path__ + "static/media/loader.b1c456c8.gif";